import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Trash2, Percent } from 'lucide-react';
import { toast } from 'sonner';
import { useCart } from '@/context/CartContext';
import { useLanguage } from '@/i18n/LanguageContext';

export const CartBundleRow = ({ bundle }) => {
  const { removeBundleFromCart, getBundleKey } = useCart();
  const { t } = useLanguage();
  const key = getBundleKey(bundle);

  return (
    <Card key={key} className="bg-card border-2 border-green-500/20">
      <CardContent className="p-4">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h3 className="font-semibold">
              {bundle.student_name ? `${bundle.name} — ${bundle.student_name}` : bundle.name}
            </h3>
            <p className="text-xs text-muted-foreground mt-0.5">
              {bundle.photo_count} {t('bundles.photosIncluded')}
              {bundle.class_name ? ` · ${bundle.class_name}` : ''}
            </p>
            {bundle.savings > 0 && (
              <div className="flex items-center gap-2 mt-2">
                <span className="text-xs line-through text-muted-foreground font-mono">
                  CHF {bundle.original_price.toFixed(2)}
                </span>
                {!bundle.fixed_price && bundle.discount_percent > 0 && (
                  <span className="text-xs bg-green-500/10 text-green-500 px-2 py-0.5 rounded-full flex items-center gap-1">
                    <Percent className="w-3 h-3" />
                    {bundle.discount_percent}%
                  </span>
                )}
              </div>
            )}
          </div>
          <div className="flex items-start gap-3">
            <div className="font-mono text-base font-bold text-primary text-right">
              CHF {bundle.discounted_price.toFixed(2)}
            </div>
            <Button
              variant="ghost" size="icon"
              onClick={() => { removeBundleFromCart(key); toast.info(t('cart.removeFromCart')); }}
              className="text-muted-foreground hover:text-destructive h-8 w-8"
              data-testid={`remove-bundle-${key}`}
            >
              <Trash2 className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
